import React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import SendIcon from '@mui/icons-material/Send';
import { API_URL } from '../../Constants';

function CommerceLoggin() {


    let apiUrl = API_URL;

    const handleFindFeasibilities = () => {
        let documentType = document.getElementById("documentType").value;
        let documentNumber = document.getElementById("documentNumber").value;
        fetch(apiUrl + '/v1/commerces/document/' + documentType + '/' + documentNumber, {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    console.log(res);
                    localStorage.setItem("commerceUuid", res.uuid);
                    window.location = '/request-status';
                })
            } else {
                alert("CommerceUuid Not Found");
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });
    }


    return (
        <Container fixed>
            <br />
            <br />
            <br />

            <Box
                component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                noValidate
                autoComplete="off"
            >
                <form>
                    <h1>Ingreso comercios</h1>
                    <TextField
                        required
                        id="documentType"
                        label="Document Type"
                        defaultValue=""
                    />
                    <br />
                    <TextField
                        required
                        id="documentNumber"
                        label="Document Number"
                        defaultValue=""
                    />
                    <br />
                    <Stack direction="row" spacing={2}>
                        <Button variant="contained" endIcon={<SendIcon />} onClick={handleFindFeasibilities} className='button'>
                            Consultar Viabilidades
                        </Button>
                    </Stack>
                </form>
            </Box>
        </Container>
    );
}

export default CommerceLoggin;